module.exports = __webpack_public_path__ + "img/logo.e960375b.png";